<template>
  <div class="home">
    <el-card shadow="always">
      <el-page-header
        @back="goBack"
        v-if="id === ''"
        content="Nova Empresa"
      ></el-page-header>
      <el-page-header
        @back="goBack"
        v-if="id !== ''"
        content="Atualizar Empresa"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        label-position="top"
        label-width="100px"
        ref="formRules"
        :model="formRules"
        :rules="rules"
      >
        <el-form-item label="Razão Social" prop="name">
          <el-input ref="name" v-model="formRules.name"></el-input>
        </el-form-item>

        <el-row :gutter="24">
          <el-col :xs="6" :sm="6" :md="6">
            <el-form-item label="CNPJ" prop="federalId">
              <el-input
                v-model="formRules.federalId"
                v-mask="'##.###.###/####-##'"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col v-if="id" :xs="12" :sm="12" :md="12">
            <el-form-item label="API-KEY" prop="apiKey">
              <el-input
                type="password"
                show-password
                v-model="formRules.apiKey"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="12" :sm="12" :md="12">
            <el-form-item label="URL PROTHEUS" prop="urlProtheus">
              <el-input v-model="formRules.urlProtheus" type="url" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="12" :sm="8" :md="6">
            <el-button type="success" size="small" @click="addNewHeaderItem"
              >Header <i class="el-icon-plus"></i
            ></el-button>
          </el-col>
        </el-row>

        <el-row
          v-for="(item, index) in formRules.headerItems"
          :key="item.key"
          :gutter="24"
        >
          <el-col :xs="12" :sm="8" :md="6">
            <el-form-item
              label="Campo"
              :prop="formRules.headerItems[index].field"
            >
              <el-input v-model="item.field" />
            </el-form-item>
          </el-col>

          <el-col :xs="12" :sm="8" :md="6">
            <el-form-item
              label="Valor"
              :prop="formRules.headerItems[index].value"
            >
              <el-input v-model="item.value" />
            </el-form-item>
          </el-col>

          <el-col :xs="12" :sm="8" :md="6">
            <el-button
              size="small"
              type="danger"
              @click.prevent="removeItem(item)"
              >Delete <i class="el-icon-delete"></i
            ></el-button>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="12" :sm="8" :md="6">
            <!-- <el-form-item label="file" prop="file">
              <el-input v-model="formRules.file" type="file" />
              <el-button size="small" type="danger" @click="removeLogoFile"
                ><i class="el-icon-delete"></i
              ></el-button>
            </el-form-item> -->
            <el-upload
              class="upload-demo"
              ref="upload"
              :limit="1"
              action=""
              :auto-upload="false"
              :file-list="file"
              list-type="picture"
            >
              <el-button size="small" type="primary">Click to upload</el-button>
              <div slot="tip" class="el-upload__tip">
                jpg/png files with a size less than 500kb
              </div>
            </el-upload>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="add()" v-if="id === ''">
            <i class="el-icon-plus"></i>&nbsp;Adicionar
          </el-button>
          <el-button type="primary" @click="update()" v-if="id !== ''">
            <i class="el-icon-check"></i>&nbsp;Atualizar
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { UserTypeEnum, UserService } from "@/services/users/user.services";
import { CompaniesService } from "@/services/companies/companies.service";

export default {
  name: "CompaniesAdd",
  components: {},
  data() {
    const checkFederalId = (rule, value, callback) => {
      if (value.length === 18) {
        return callback();
      }
      return callback(new Error("Inserir um CNPJ válido."));
    };

    return {
      id: "",
      file: [],
      formRules: {
        name: "",
        federalId: "",
        out: false,
        urlProtheus: "",
        headerItems: [],
        apiKey: ""
      },
      rules: {
        name: [{ required: true, message: "Informe um nome", trigger: "blur" }],
        federalId: [{ validator: checkFederalId, trigger: "blur" }],
        urlProtheus: [
          {
            required: true,
            message: "Informe a url padrão para busca dos clientes."
          }
        ]
      }
    };
  },
  methods: {
    removeLogoFile() {
      const vm = this;
      vm.formRules.file = "";
    },
    addNewHeaderItem() {
      const vm = this;
      vm.formRules.headerItems.push({
        key: Date.now(),
        field: "",
        value: ""
      });
    },
    removeItem(item) {
      const vm = this;
      let index = vm.formRules.headerItems.indexOf(item);
      if (index !== -1) vm.formRules.headerItems.splice(index, 1);
    },
    transformCnpj: function(cnpj) {
      cnpj = cnpj.replace(/\D/g, "");
      cnpj = cnpj.replace(/^(\d{2})(\d)/, "$1.$2");
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, ".$1/$2");
      cnpj = cnpj.replace(/(\d{4})(\d)/, "$1-$2");
      return cnpj;
    },
    goBack: function() {
      const vm = this;
      vm.$router.push({ name: "company" });
    },
    add: function() {
      const vm = this;
      this.$refs.formRules.validate(valid => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });

          const headerItems = {
            items: vm.formRules.headerItems.map(value => {
              return { field: value.field, value: value.value };
            })
          };

          const file = vm.$refs.upload.uploadFiles || undefined;

          CompaniesService.add({
            companyName: vm.formRules.name,
            federalId: vm.formRules.federalId,
            urlProtheus: vm.formRules.urlProtheus,
            headerProtheus: headerItems,
            logo: file
          })
            .then(() => {
              this.$message({
                type: "success",
                message: "Empresa criado com sucesso!"
              });
              this.$refs.formRules.resetFields();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error
              });
            })
            .finally(() => loading.close());
        } else {
          return this.$message({
            type: "error",
            message: "Preencha os campos obrigatórios!"
          });
        }
      });
    },
    update: function() {
      const vm = this;
      this.$refs.formRules.validate(valid => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });

          const headerItems = {
            items: vm.formRules.headerItems.map(value => {
              return { field: value.field, value: value.value };
            })
          };

          const file = vm.$refs.upload.uploadFiles || undefined;

          CompaniesService.update({
            id: vm.id,
            companyName: vm.formRules.name,
            federalId: vm.formRules.federalId,
            urlProtheus: vm.formRules.urlProtheus,
            headerProtheus: headerItems,
            logo: file
          })
            .then(() => {
              this.$message({
                type: "success",
                message: "Empresa atualizada com sucesso!"
              });
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error
              });
            })
            .finally(() => loading.close());
        } else {
          return this.$message({
            type: "error",
            message: "Preencha os campos obrigatórios!"
          });
        }
      });
    },
    get: function() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      CompaniesService.get(vm.id)
        .then(response => {
          const federalId = response.federalId;
          vm.formRules.federalId = this.transformCnpj(federalId);

          vm.formRules.apiKey = response.apiKey;
          vm.formRules.name = response.companyName;
          vm.formRules.out = response.out;
          if (response.headerProtheus && response.headerProtheus.items) {
            vm.formRules.headerItems = response.headerProtheus.items;
          } else {
            vm.formRules.headerItems = [];
          }
          // vm.formRules.headerItems = response?.headerProtheus?.items || [];

          if (response.urlProtheus) {
            vm.formRules.urlProtheus = response.urlProtheus;
          } else {
            vm.formRules.urlProtheus = "";
          }
          // vm.formRules.urlProtheus = response?.urlProtheus || "";
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error
          });
        })
        .finally(() => loading.close());
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then(response => {
        if (response.user.type !== UserTypeEnum.MASTER) {
          vm.$router.push({ name: "home" });
        }
      })
      .catch(() => {
        vm.$router.push({ name: "home" });
      });

    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.name.$el.children[0].focus();
    }
  }
};
</script>
